import { ToastrService } from 'ngx-toastr';
import { Usuarios } from 'app/models/Usuario/usuarios.model';

import { UsuarioService } from 'app/modules/admin/usuarios/usuario.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreoAnimations } from '@treo/animations';


@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: TreoAnimations
})
export class DialogComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogComponent>, private usuarioService: UsuarioService, private toast: ToastrService) { }
    usuario: Usuarios = JSON.parse(localStorage.getItem('usuario'));
    public vendedor: Usuarios = new Usuarios();
    public formulario: FormGroup;
    public maskTelefone = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public maskComissao = [/[1-9]/, /[0-9]/];
    public span = true;
    public titulo: string;
    public gerentes: Usuarios[] = [];
    public carregouGerentes: boolean = false;
    public codigoVendedor: string = '';
    public tipoChave: string = 'telefone'; // Define o valor padrão
    maskOptions: any;

    setMask(tipo: string): void {
        if (tipo === 'telefone') {
          this.maskOptions = { mask: '(00) 00000-0000' };
        } else if (tipo === 'cpf') {
          this.maskOptions = { mask: '000.000.000-00' };
        } else{
            this.maskOptions = null;
        }


      }

    ngOnInit(): void {



        this.setMask(this.tipoChave); // Aplica a máscara padrão

        this.titulo = "Cadastre-se";

            this.formulario = new FormGroup({
                nome: new FormControl('', Validators.required),
                usuario: new FormControl('', Validators.required),
                senha: new FormControl('', Validators.required),
                telefone: new FormControl('', Validators.required),
                chave_pix: new FormControl('', Validators.required),
                codigo_vendedor: new FormControl({
                    value: this.data.codigo != '' ? this.data.codigo : '',
                    disabled: this.data.codigo != '' && this.data.codigo != null
                  }),
                status: new FormControl('Ativo', Validators.required),
                tipo: new FormControl('Apostador', Validators.required),
                criado_por: new FormControl('site', Validators.required),
                comissao: new FormControl(0, Validators.required),
                gerente: new FormControl(null)
            });



    }



    fecharDialog() {

        this.dialogRef.close("Fechar");

    }

    salvar(formulario: FormGroup) {

        this.span = false;

        if (formulario.valid) {

            this.vendedor = formulario.value;
            if(this.data.codigo != ''){
                this.vendedor.agente = this.data.codigo;
            }else if (formulario.value.codigo_vendedor != ''){
                this.vendedor.agente = formulario.value.codigo_vendedor;
            }else{
                this.vendedor.agente = null;
            }

            this.usuarioService.criarApostador(this.vendedor).subscribe(response => {

                if (response == "Criou") {
                    this.span = true;
                    formulario.enable();
                    this.dialogRef.close(response);
                } else {
                    this.toast.error(
                        "Erro ao realizar cadastro!",
                        response
                    );
                    this.span = true;
                    formulario.enable();
                }
            });




        } else {

            console.log("Formulário invalido");
            formulario.enable();
            this.span = true;
        }
    }
}
